import { createSelector } from 'reselect';
import { isFetchingCompanyCodesSelector } from '../../../shared/store/selectors';
import UserRoles from '../../../shared/authorization/userRoles';
import { userSelector } from '../../../userData/store/selectors';
import { assignmentPermissions, assignmentTypes } from '../../../shared/authorization';
import keyBy from 'lodash/keyBy';

export const companyCodesForConnectionSelector = ({ provision }) =>
  provision.batchProvisions.companyCodesForConnection;

export const isLoadingCompanyCodesForConnectionSelector = ({ provision }) =>
  provision.batchProvisions.isLoadingCompanyCodesForConnection;

export const isFetchingBatchProvisionsSelector = ({ provision }) =>
  provision.batchProvisions.isFetching;

export const isStartingCalcBatchProvisionsSelector = ({ provision }) =>
  provision.batchProvisions.isStartingCalc;

export const isRefreshingStatusSelector = createSelector(
  isFetchingCompanyCodesSelector,
  isFetchingBatchProvisionsSelector,
  (isFetchingCompanyCodes, isFetchingBatchProvisions) => isFetchingCompanyCodes || isFetchingBatchProvisions
);

export const canLoadTrialBalanceAndCalculateSelector = createSelector(
  userSelector,
  companyCodesForConnectionSelector,
  (user, companyCodesForConnection) => {
    if (user.role === UserRoles.SUPER_USER) {
      return true;
    }

    const hasAllAssignment = user.allAssignments.includes(assignmentPermissions.Modify);
    if (hasAllAssignment) {
      return true;
    }

    const companyCodesWithLoadTBAssignment = keyBy(
      user.assignments
        .filter(({ assignmentType, privileges }) => assignmentType === assignmentTypes.CC
          && privileges.includes(assignmentPermissions.Modify)
        ),
      'assignment_code'
    );
    if (companyCodesForConnection.every(({ companyCode }) => Boolean(companyCodesWithLoadTBAssignment[companyCode]))) {
      return true;
    }
    return false;
  }
);
